<template>
  <div class="main">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd" class="mb20"
      v-show="$ButtonShow('IPN_ADD_01')">新增</el-button>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="计划类型" show-overflow-tooltip prop="planType">
        <template v-slot="{ row }">
          <span>{{ row.planType === '1' ? '定时计划' : '智能计划' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="计划名称" show-overflow-tooltip prop="planName"></el-table-column>
      <el-table-column label="区域名称" show-overflow-tooltip prop="areaName"></el-table-column>
      <el-table-column label="状态" show-overflow-tooltip prop="planStatus">
        <template v-slot="{ row }">
          <el-switch v-show="$ButtonShow('IPN_EDT_05')" @change="change(row.planId)" v-model="row.status"
            active-color="var(--color-primary)" inactive-color="#BFBFBF">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="开始日期" show-overflow-tooltip prop="startDate"></el-table-column>
      <el-table-column label="结束日期" show-overflow-tooltip prop="endDate"></el-table-column>
      <el-table-column label="开启时间" show-overflow-tooltip prop="executeTime"></el-table-column>
      <el-table-column label="触发阈值(%)" show-overflow-tooltip prop="drought"></el-table-column>
      <el-table-column label="创建时间" min-width="100" show-overflow-tooltip prop="ctime"></el-table-column>
      <el-table-column label="操作" min-width="80px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" :disabled="scope.row.planStatus !== 'N'" @click="onUpdate(scope.row.planId)"
            v-show="$ButtonShow('IPN_EDT_01')">编辑</el-button>
          <el-button type="text" @click="onDetail(scope.row.planId)">详情</el-button>
          <el-button v-if="scope.row.roleCatalog !== '1'" :disabled="scope.row.planStatus !== 'N'" type="text"
            @click="onDelete(scope.row.planId)" v-show="$ButtonShow('IPN_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </global-pagination>
    <IrrigationPlanAdd :showDialog.sync="showDialog" :id="id" @success="success"></IrrigationPlanAdd>
    <IrrigationPlanDetail :showDialog.sync="showDialog1" :id="id1" @success="success"></IrrigationPlanDetail>
  </div>
</template>

<script>
import IrrigationPlanAdd from './IrrigationPlanAdd.vue'
import IrrigationPlanDetail from './IrrigationPlanDetail.vue'

export default {
  name: 'IrrigationPlan',
  components: {
    IrrigationPlanAdd,
    IrrigationPlanDetail
  },
  data () {
    return {
      tableData: [],
      page: 1,
      size: 10,
      total: 0,
      loading: true,
      showDialog: false,
      showDialog1: false,
      id: '',
      id1: ''

    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.irrigation.selectIrrigationPlanByPage, {
        page: this.page,
        size: this.size,
        projectId: this.$route.query.projectId
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
        this.tableData.forEach((item) => {
          item.status = item.planStatus !== 'N'
        })
      }).finally(() => {
        this.loading = false
      })
    },

    change (id) {
      this.$axios.post(this.$apis.irrigation.updateIrrigationPlanStatus, {
        planId: id
      }).then(() => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.loadData()
      })
    },

    onAdd () {
      this.showDialog = true
    },

    onUpdate (id) {
      this.showDialog = true
      this.id = id
    },

    success () {
      this.id = ''
      this.loadData()
    },

    onDelete (id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.irrigation.deleteIrrigationPlan, {
          planId: id
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.page = 1
          this.loadData()
        })
      })
    },

    onDetail (id) {
      this.id1 = id
      this.showDialog1 = true
    }
  }

}
</script>

<style scoped lang="scss"></style>
